import { Strategy } from 'utility-ts-strategy';

interface ICoreConfig {
  full_name?: string;
  short_name?: string;
  privacy_policy_url?: string;
  onet_area_code?: string;
  transfer_counselor_email?: string;
  pending_course_contact_email?: string;
  enable_pending_course_resolution_email?: string;
  enable_additional_course_info?: boolean;
  enable_additional_course_info_term?: boolean;
  enable_additional_course_info_credits?: boolean;
  enable_additional_course_info_grade?: boolean;
}

export interface IConfig {
  core_config: ICoreConfig;
}

export interface ISitesetupCapability {
  configUrl: string;
}

interface IAdditionalCourseInfoFieldConfig {
  value: boolean;
}

export class SitesetupConfiguration {
  private _capability: ISitesetupCapability;
  private _config: IConfig;

  constructor() {}

  configureCapability(capability: ISitesetupCapability) {
    this._capability = capability;
  }

  get capability() {
    return this._capability;
  }

  setupConfig(config: IConfig) {
    this._config = config;
  }

  get config() {
    return this._config;
  }

  $get() {
    return this;
  }

  get isAdditionalPendingCourseInfoEnabled() {
    return (
      !!this._config.core_config.enable_additional_course_info &&
      (!!this._config.core_config.enable_additional_course_info_term ||
        !!this._config.core_config.enable_additional_course_info_grade)
    );
  }

  get isAdditionalCourseInfoEnabled() {
    return (
      this.isAdditionalCourseInfoFieldEnabled('term') ||
      this.isAdditionalCourseInfoFieldEnabled('credits') ||
      this.isAdditionalCourseInfoFieldEnabled('grade')
    );
  }

  isAdditionalCourseInfoFieldEnabled(field: string): boolean {
    const config = this._config.core_config;
    if (!_.get(config, 'enable_additional_course_info', false)) {
      return false;
    }

    const additionalCourseInfoFieldEnabledstrategy = new Strategy<IAdditionalCourseInfoFieldConfig>({
      term: {
        value: !!_.get(config, 'enable_additional_course_info_term', false)
      },
      credits: {
        value: !!_.get(config, 'enable_additional_course_info_credits', false)
      },
      grade: {
        value: !!_.get(config, 'enable_additional_course_info_grade', false)
      }
    });
    return additionalCourseInfoFieldEnabledstrategy.getByKey(field).value;
  }
}

angular.module('capability-ng-sitesetup').provider('ngSitesetupConfiguration', SitesetupConfiguration);



// WEBPACK FOOTER //
// ./app/lib/sitesetup/config/sitesetup_configuration.ts